import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as ShopService from '@/services/ShopService';
import type { Shop } from '@/types/company';

export const useCreateShop = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      companyId,
      data,
    }: {
      companyId: string;
      data: Omit<Shop, 'id' | 'companyId'>;
    }) => ShopService.createShop(companyId, data),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['companies', companyId] });
    },
  });
};

export const useUpdateShop = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      companyId,
      shopId,
      data,
    }: {
      companyId: string;
      shopId: string;
      data: Partial<Omit<Shop, 'id' | 'companyId'>>;
    }) => ShopService.updateShop(companyId, shopId, data),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['companies', companyId] });
    },
  });
};

export const useDeleteShop = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ companyId, shopId }: { companyId: string; shopId: string }) =>
      ShopService.deleteShop(companyId, shopId),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['companies', companyId] });
    },
  });
};
